<template>
  <div class="banner-slider-wrapper banner-video-banner">
    <div class="banner-parallax" data-parallax="0.18">
      <video
        ref="bannerVideo"
        class="banner-video"
        :key="videoSrc"
        :src="videoSrc"
        :autoplay="!prefersReducedMotion"
        muted
        loop
        playsinline
        preload="auto"
        aria-label="Peak Pursuits"
      ></video>
    </div>
  </div>
</template>

<script>
const DESKTOP_QUERY = "(min-width: 672px)";

export default {
  name: "BannerSlider",
  data() {
    return {
      isDesktop:
        typeof window !== "undefined" &&
        window.matchMedia(DESKTOP_QUERY).matches,
      prefersReducedMotion:
        typeof window !== "undefined" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      desktopVideo: require("@/assets/videos/peakpursuits-desktop-video.mp4"),
      mobileVideo: require("@/assets/videos/peakpursuits-mobile-video.mp4"),
    };
  },
  computed: {
    videoSrc() {
      return this.isDesktop ? this.desktopVideo : this.mobileVideo;
    },
  },
  watch: {
    videoSrc() {
      this.$nextTick(() => this.playVideo());
    },
  },
  mounted() {
    this.mediaQuery = window.matchMedia(DESKTOP_QUERY);
    this.onViewportChange = (event) => {
      this.isDesktop = event.matches;
    };
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.onViewportChange);
    } else {
      this.mediaQuery.addListener(this.onViewportChange);
    }
    this.playVideo();
  },
  beforeUnmount() {
    if (!this.mediaQuery || !this.onViewportChange) return;
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener("change", this.onViewportChange);
    } else {
      this.mediaQuery.removeListener(this.onViewportChange);
    }
  },
  methods: {
    playVideo() {
      const video = this.$refs.bannerVideo;
      if (!video || this.prefersReducedMotion) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.banner-slider-wrapper.banner-video-banner:not(.custom-block) {
  aspect-ratio: auto !important;

  .banner-parallax {
    overflow: hidden;
    border-radius: 20px;
  }

  .banner-video {
    width: 100%;
    height: auto;
    aspect-ratio: 3 / 2;
    object-fit: cover;
    display: block;
    background: #000;
    transform: scale(1.25);
    will-change: transform;
  }
}

@media (prefers-reduced-motion: reduce) {
  .banner-slider-wrapper.banner-video-banner:not(.custom-block) .banner-video {
    transform: none;
  }
}

@media (min-width: 672px) {
  .banner-slider-wrapper.banner-video-banner:not(.custom-block) {
    .banner-video {
      aspect-ratio: 3.5 / 1;
    }
  }
}
</style>
